'use client';

import { ProductCategory } from '@/helper/enums';
import { useSettings } from '@/providers/SettingsProvider';
import HouseIcon from '@/public/icons/house.svg';
import PersonIcon from '@/public/icons/persons.svg';
import type { PartialStepSettingStoryblok } from '@/types/component-types-sb';

import IconSelect, { type IconSelectValue } from './IconSelect';
import classes from './IconSelectCalculator.module.scss';

const IconSelectCalculator: React.FC<{
  type: ProductCategory;
  selected: PartialStepSettingStoryblok | undefined;
  setSelectedStep: React.Dispatch<React.SetStateAction<PartialStepSettingStoryblok | undefined>>;
  label?: string;
  initiallyUnset?: boolean;
  helperText?: string;
  disabled?: boolean;
  error?: boolean;
}> = ({ type, selected, setSelectedStep, label, initiallyUnset, helperText, disabled, error }) => {
  const settingsStore = useSettings();
  const consumptionSteps =
    type === ProductCategory.Electricity
      ? settingsStore?.consumption_steps_electricity
      : settingsStore?.consumption_steps_gas;
  const iconSelectValues: IconSelectValue<PartialStepSettingStoryblok>[] = [];

  consumptionSteps?.forEach((step) => {
    iconSelectValues.push({
      key: step,
      label: step.label,
      icon:
        type === ProductCategory.Electricity ? (
          <IconElectricity step={step} selected={step === selected} />
        ) : (
          <IconGas step={step} selected={step === selected} />
        ),
    });
  });

  return (
    <IconSelect<PartialStepSettingStoryblok | undefined>
      selected={selected}
      setSelected={setSelectedStep}
      values={iconSelectValues}
      label={label}
      error={error}
      helperText={helperText}
      disabled={disabled}
    />
  );
};

const IconGas: React.FC<{
  step: PartialStepSettingStoryblok;
  selected: boolean;
}> = ({ step, selected }) => {
  return (
    <div className={classes.iconGas}>
      {selected && <HouseIcon aria-hidden={true} />}
      <span>{step.key}</span>
    </div>
  );
};

const IconElectricity: React.FC<{
  step: PartialStepSettingStoryblok;
  selected: boolean;
}> = ({ step, selected }) => {
  return (
    <div className={classes.iconElectricity}>
      {selected && <PersonIcon aria-hidden={true} />}
      <span>{step.key}</span>
    </div>
  );
};

export default IconSelectCalculator;
